// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"fcb70dbb","111":"5ba28ec8","115":"a5813366","363":"b6641ed2","481":"39b528bf","663":"81d04ad2","742":"0be64339","797":"b4453007","867":"ed0ffba6","950":"bba35825"}[chunkId] + ".chunk.js";
};